import { useState, useEffect } from 'react'
import { cn } from 'ethcss'
import { styles } from './animationWrapper.jcss'
import React from 'react'

interface AnimationWrapperProps {
    children: React.ReactNode
}

const AnimationWrapper: React.FC<AnimationWrapperProps> = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setIsVisible(true)
        }, 10)
        return () => {
            setTimeout(() => setIsVisible(false))
        }
    }, [])

    return (
        <>
            {React.Children.map(children, (child) => {
                if (!React.isValidElement<{ className?: string }>(child)) return child

                return React.cloneElement(child, {
                    className: cn(
                        child.props.className || '', // Сохраняем существующие классы
                        styles.fadeNormalEnter,
                        isVisible && styles.fadeNormalEnterActive,
                        styles.fadeNormalLeave,
                        !isVisible && styles.fadeNormalLeaveActive
                    ),
                });
            })}
        </>
    );
};

export default AnimationWrapper;
